import { customElement } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { DelayedPanicRequestModel, MobileAppEvent } from 'model/mobile-app-dashboard';

@customElement('events-list')
export class EventsListCustomElement {
  @bindable
  delayedPanicRequests: DelayedPanicRequestModel[];
  @bindable
  events: MobileAppEvent[];
}
